module.exports = __webpack_public_path__ + "static/media/599.7554(31).4b962576.pdf";